module.exports = __webpack_public_path__ + "img/angle_ac.9bdd8fa6.png";